import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { ClickOutsideDirective } from './../directives/click-outside.directive';

@Component({
  selector: 'mpro-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss']
})
export class ModalComponent {
  faTimes = faTimes

  @HostListener('document:keydown.escape', ['$event'])
  public onKeydownHandler(evt: KeyboardEvent) {
    this.close();
  }

  @Input() public open: boolean = false;
  @Input() public title: string;
  @Input() public titleInfo?: string;
  @Input() public showCloseButton: boolean = true;
  @Output() public openChange: EventEmitter<boolean> = new EventEmitter();

  public checkIfNeedsToBeClosed(event: MouseEvent, modalBody: HTMLElement) {
    if (ClickOutsideDirective.isClickedOutside(event, modalBody) && !event.composedPath().some(el => el === modalBody)) {
      this.close();
    }
  }

  public close(): void {
    this.open = false;
    this.openChange.emit(false);
  }
}
